import { getOptions } from 'components/common/InputSelect/inputSelect.utils';

import {
  IsMainContactOption,
  AccountStatus,
  SortDirection,
  UsersTableColumnsTitle,
  UsersTableSortField,
} from './users.enums';
import { UsersPageFilters } from './users.types';

export const USERS_TABLE_COLUMNS = [
  {
    title: UsersTableColumnsTitle.Name,
    sortField: UsersTableSortField.Name,
  },
  {
    title: UsersTableColumnsTitle.Email,
  },
  {
    title: UsersTableColumnsTitle.Phone,
  },
  {
    title: UsersTableColumnsTitle.Role,
  },
  {
    title: UsersTableColumnsTitle.MainContact,
  },
  {
    title: '',
  },
];
export const MAX_USERS_PER_PAGE = 10;
export const USERS_TABLE_COLUMNS_AMOUNT = 5;
export const DEFAULT_USERS_TABLE_FILTERS: UsersPageFilters = {
  pageIndex: 0,
  pageSize: MAX_USERS_PER_PAGE,
  sortField: UsersTableSortField.Name,
  sortDirection: SortDirection.Asc,
};
export const NOT_CONFIRMED_EMAIL_WARNING_MESSAGE = 'This email is not confirmed yet';
export const IS_MAIN_CONTACT_SELECT_OPTIONS = getOptions(IsMainContactOption);
export const MAX_PERCENTAGE_OWNED = 100;
export const MAX_PERCENTAGE_OWNED_ERROR_MESSAGE = 'Must Not Be Greater Than 100%';
export const MIN_PERCENTAGE_OWNED = 1;
export const MIN_PERCENTAGE_OWNED_ERROR_MESSAGE = 'Must Not Be Less Than 1%';
export const ACCOUNT_STATUS_SELECT_OPTIONS = getOptions(AccountStatus).map((option) => ({
  ...option,
  disabled: option.value === AccountStatus.Pending,
}));

export const accountStatusesForUpdate = [AccountStatus.Active, AccountStatus.Disabled];
export const ACCOUNT_STATUS_TOOLTIP = `Active - User is able to log in to the portal.
Pending - User has been invited to the portal, but has not completed verification.
Disabled - User is not able to log into the portal.`;
